"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4208],{

/***/ 79096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ Slider; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(79215);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(9221);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(46626);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/autoplay/autoplay.js
var autoplay = __webpack_require__(13341);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/components/virtual/virtual.js
var virtual = __webpack_require__(55540);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Slider/helper.es.js
const renderPaginationStyle = (index, theme, paginationColor) => {
  const styleArr = [
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
      width: 24px;
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #ddd;
      cursor: pointer;
      &:first-of-type {
        border-radius: 999px 0 0 999px;
      };
      &:last-of-type {
        border-radius: 0 999px 999px 0;
      }
    }
    .swiper-pagination-bullet-active {
      width: 24px;
      position: relative;
      &:after {
        content: "";
        border-radius: 999px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${paginationColor};
      }
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
      width: 12px;
      height: 12px;
      border-radius: 50%;
      transform: translateY(2px);
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};
const renderSwipeButton = (index) => {
  const styleArr = [
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-right: 0.5rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-left: 1rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};



// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(49713);
// EXTERNAL MODULE: ../../.yarn/unplugged/swiper-npm-6.8.4-cb66fb3b39/node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(18668);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-46f73e5ea2/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(17016);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Slider/Slider.es.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
core_class/* default.use */.Z.use([navigation/* default */.Z, pagination/* default */.Z, autoplay/* default */.Z, virtual/* default */.Z]);
const Slider = (_a) => {
  var _b = _a, {
    className,
    children,
    paginationStyle,
    navigationStyle,
    speed = 3e3,
    pauseOnMouseEnter = true,
    paginationColor,
    virtual = true
  } = _b, swiperProps = __objRest(_b, [
    "className",
    "children",
    "paginationStyle",
    "navigationStyle",
    "speed",
    "pauseOnMouseEnter",
    "paginationColor",
    "virtual"
  ]);
  const {
    slidesPerView,
    slidesPerGroup,
    slidesPerColumn,
    pagination,
    autoplay,
    loop
  } = swiperProps;
  const [swiperKey, setSwiperKey] = (0,react.useState)(0);
  const isMultipleRows = slidesPerColumn && slidesPerColumn > 1;
  if (pagination) {
    swiperProps.pagination = {
      clickable: true
    };
  }
  if (isMultipleRows)
    swiperProps.loop = false;
  if (autoplay) {
    swiperProps.autoplay = {
      delay: speed,
      disableOnInteraction: false,
      pauseOnMouseEnter
    };
  }
  if (!slidesPerGroup)
    swiperProps.slidesPerGroup = slidesPerView;
  (0,react.useEffect)(() => {
    setSwiperKey((key) => key + 1);
  }, [autoplay, loop, speed, pauseOnMouseEnter, virtual, slidesPerColumn]);
  return /* @__PURE__ */ react.createElement(Wrapper, {
    className,
    paginationStyle,
    navigationStyle,
    isMultipleRows,
    paginationColor
  }, /* @__PURE__ */ react.createElement(swiper/* Swiper */.t, __spreadProps(__spreadValues({
    key: `swiper-${swiperKey}`
  }, swiperProps), {
    slidesPerColumnFill: "row",
    resizeObserver: true,
    virtual: virtual ? {
      addSlidesBefore: slidesPerView
    } : false
  }), react.Children.map(children, (child, index) => /* @__PURE__ */ react.createElement(swiper_slide/* SwiperSlide */.o, {
    key: index,
    virtualIndex: index
  }, child))));
};
const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(({
  isMultipleRows,
  paginationStyle,
  paginationColor,
  navigationStyle,
  theme
}) => `
    .swiper-container {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      list-style: none;
      padding: 0;
    }
    .swiper-wrapper {
      position: relative;
      height: 100%;
      display: flex;
      transition-property: transform;
      box-sizing: content-box;
      flex-wrap: ${isMultipleRows ? "wrap" : "nowrap"};
    }
    .swiper-slide {
      flex-shrink: 0;
      height: 100%;
      position: relative;
      transition-property: transform;
      ${isMultipleRows ? `margin-top: 0px !important` : ""};
    }
    &:hover {
      .swiper-button-next,
      .swiper-button-prev {
        opacity: 1;
        &.swiper-button-disabled {
          opacity: 0.35;
        }
      }
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-pagination-fraction {
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .swiper-pagination-bullets {
      bottom: 10px;
      left: 0;
      width: 100%;
    }
    ${renderPaginationStyle(paginationStyle, theme, paginationColor)};
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      top: 50%;
      z-index: 10;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      margin-top: -22px;
      opacity: 0;
      &.swiper-button-disabled {
        opacity: 0;
        cursor: auto;
        pointer-events: auto;
      }
    }
    ${renderSwipeButton(navigationStyle)};
`);




/***/ }),

/***/ 97161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Countdown; }
});

// EXTERNAL MODULE: ../../packages/types/dist/shared/index.es.js + 1 modules
var index_es = __webpack_require__(84019);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(68481);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-46f73e5ea2/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(17016);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Countdown/DefaultCountdown.es.js





const sizeMaps = {
  [index_es/* DSSize.small */.hT.small]: "24px",
  [index_es/* DSSize.default */.hT["default"]]: "45px",
  [index_es/* DSSize.large */.hT.large]: "55px"
};
const fontSizeMaps = {
  [index_es/* DSSize.small */.hT.small]: "12px",
  [index_es/* DSSize.default */.hT["default"]]: "20px",
  [index_es/* DSSize.large */.hT.large]: "24px"
};
const DefaultCountdown = ({
  duration,
  size
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, duration.days > 0 && /* @__PURE__ */ react.createElement(CountdownText, null, (0,i18n_es.t)("K\u1EBFt th\xFAc sau"), " ", /* @__PURE__ */ react.createElement(Bold, null, duration.days), " ", (0,i18n_es.t)("ng\xE0y")), duration.milliseconds > 0 && /* @__PURE__ */ react.createElement(Timer, null, /* @__PURE__ */ react.createElement(Pad, {
    size
  }, duration.hours.toString().padStart(2, "0")), /* @__PURE__ */ react.createElement(Pad, {
    size
  }, duration.minutes.toString().padStart(2, "0")), /* @__PURE__ */ react.createElement(Pad, {
    size
  }, duration.seconds.toString().padStart(2, "0"))));
};
const CountdownText = emotion_styled_browser_esm/* default.p */.Z.p`
  color: #fff;
  text-align: center;
  font-size: 1rem;
`;
const Bold = emotion_styled_browser_esm/* default.span */.Z.span`
  font-weight: 600;
  font-size: 1.3rem;
`;
const Timer = emotion_styled_browser_esm/* default.div */.Z.div`
  display: flex;
  justify-content: center;
`;
const Pad = emotion_styled_browser_esm/* default.div */.Z.div(({ size }) => `
  width: ${sizeMaps[size]};
  height: ${sizeMaps[size]};
  font-size: ${fontSizeMaps[size]};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-right: 8px;
  color: white;
  border-radius: 5px;
  background-image: linear-gradient(rgb(74, 74, 74), rgb(35, 34, 34));
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/hooks/useTimer.es.js
var useTimer_es = __webpack_require__(63860);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Countdown/Countdown.es.js





const DefaultRenderer = (duration, size = index_es/* DSSize.default */.hT["default"]) => /* @__PURE__ */ react.createElement(DefaultCountdown, {
  duration,
  size
});
const Countdown = ({
  date,
  renderer = DefaultRenderer,
  size = index_es/* DSSize.default */.hT["default"],
  className
}) => {
  const timer = (0,useTimer_es/* useTimer */.J)(date);
  return /* @__PURE__ */ react.createElement("div", {
    className
  }, renderer && renderer(timer, size));
};




/***/ }),

/***/ 34469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ HorizontalSlider; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HorizontalSlider = (_a) => {
  var _b = _a, {
    slidesPerView,
    children
  } = _b, props = __objRest(_b, [
    "slidesPerView",
    "children"
  ]);
  if (!Array.isArray(children)) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), Array.isArray(children) && children.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    slidesPerView,
    key: index
  }, item)));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F, () => `
  display: flex;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  };
  transform: translate3d(0,0,0);
  `);
const Item = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
    width: ${100 / props.slidesPerView}%;
    flex-shrink: 0;
    margin-right: 8px;
  `);




/***/ }),

/***/ 92316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ MobileProductCard; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/hook.es.js
var hook_es = __webpack_require__(98992);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(71323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(24122);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Quantity/Quantity.es.js
var Quantity_es = __webpack_require__(38149);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(88384);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-46f73e5ea2/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(17016);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Tag/Tag.es.js
var Tag_es = __webpack_require__(49800);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/GiftColored.es.js
var GiftColored_es = __webpack_require__(43328);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/FreeShippingColored.es.js
var FreeShippingColored_es = __webpack_require__(19782);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(68481);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/FlashSaleBadge/MobileFlashSaleBadge.es.js




const background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgzNkMzOC4yMDkxIDAgNDAgMS43OTA4NiA0MCA0VjM1LjgzODdDNDAgMzcuNTE1OCAzOC4wNjAxIDM4LjQ0ODEgMzYuNzUwNiAzNy40MDA1TDM2LjI0OTQgMzYuOTk5NUMzNS41MTkgMzYuNDE1MiAzNC40ODEgMzYuNDE1MiAzMy43NTA2IDM2Ljk5OTVMMzEuMjQ5NCAzOS4wMDA1QzMwLjUxOSAzOS41ODQ4IDI5LjQ4MSAzOS41ODQ4IDI4Ljc1MDYgMzkuMDAwNUwyNi4yNDk0IDM2Ljk5OTVDMjUuNTE5IDM2LjQxNTIgMjQuNDgxIDM2LjQxNTIgMjMuNzUwNiAzNi45OTk1TDIxLjI0OTQgMzkuMDAwNUMyMC41MTkgMzkuNTg0OCAxOS40ODEgMzkuNTg0OCAxOC43NTA2IDM5LjAwMDVMMTYuMjQ5NCAzNi45OTk1QzE1LjUxOSAzNi40MTUyIDE0LjQ4MSAzNi40MTUyIDEzLjc1MDYgMzYuOTk5NUwxMS4yNDk0IDM5LjAwMDVDMTAuNTE5IDM5LjU4NDggOS40ODEwNSAzOS41ODQ4IDguNzUwNjEgMzkuMDAwNUw2LjI0OTM5IDM2Ljk5OTVDNS41MTg5NSAzNi40MTUyIDQuNDgxMDUgMzYuNDE1MiAzLjc1MDYxIDM2Ljk5OTVMMy4yNDkzOSAzNy40MDA1QzEuOTM5ODYgMzguNDQ4MSAwIDM3LjUxNTggMCAzNS44Mzg3VjRaIgogICAgZmlsbD0iI0ZGREU2NyIgLz4KPC9zdmc+";
const SIZE = {
  s: {
    badge: 36,
    discountText: 8,
    percentText: 13
  },
  m: {
    badge: 40,
    discountText: 10,
    percentText: 15
  }
};
const MobileFlashSaleBadge = ({
  discountPercent
}) => {
  return discountPercent ? /* @__PURE__ */ react.createElement(DiscountInfo, {
    size: "s",
    background
  }, /* @__PURE__ */ react.createElement(DiscountText, {
    size: "s"
  }, (0,i18n_es.t)("GI\u1EA2M")), /* @__PURE__ */ react.createElement(PercentText, {
    size: "s"
  }, discountPercent, "%")) : null;
};
const DiscountText = emotion_styled_browser_esm/* default.div */.Z.div(({ size }) => `
    font-weight: 700;
    color: #663009;
    line-height: 12px;
    font-size: ${SIZE[size].discountText}px;
`);
const PercentText = emotion_styled_browser_esm/* default.div */.Z.div(({ size }) => `
    font-weight: 700;
    font-size: ${SIZE[size].percentText}px;
    line-height: 18px;
    color: #ee112e;
`);
const DiscountInfo = emotion_styled_browser_esm/* default.div */.Z.div(({ size, background: background2 }) => `
    width: ${SIZE[size].badge}px;
    height: ${SIZE[size].badge}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url("${background2}");
    background-repeat: no-repeat;
    background-size: cover;
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/helpers/number.es.js
var number_es = __webpack_require__(57732);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/SavingBadge/MobileSavingBadge.es.js





const MobileSavingBadge_es_background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA5NiA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iNDAiIHJ4PSI0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIiAvPgogIDxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9Ijk2IiBoZWlnaHQ9IjQwIj4KICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI0MCIgcng9IjQiIGZpbGw9IndoaXRlIiAvPgogIDwvbWFzaz4KICA8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CiAgICA8cGF0aCBvcGFjaXR5PSIwLjMiCiAgICAgIGQ9Ik03NC4yNDQ2IC05LjAyODY5TDY1Ljg3NjcgOC45MTYyMUw3MC43NzA4IDExLjE5ODNMNjMuOTI0NCAyNS44ODA1TDg0LjQ3MjQgMTEuNjI5M0w3Ny45NDcgOC41ODY0Mkw5MC41NTgxIC0xLjQyMTU2TDc0LjI0NDYgLTkuMDI4NjlaIgogICAgICBmaWxsPSIjMUIxRDI5IiAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjM1LjcyMDkiIHkxPSIxLjY2NTQ0ZS0wNiIgeDI9IjU3Ljg4ODYiIHkyPSI0MC4wODczIgogICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNBQTIwRkYiIC8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzQxM0VGRiIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgo8L3N2Zz4=";
const MobileSavingBadge_es_SIZE = {
  s: {
    titleFont: 8,
    discountFont: 12,
    discountLineHeight: 16
  },
  m: {
    titleFont: 10,
    discountFont: 13,
    discountLineHeight: 18
  }
};
const MobileSavingBadge = ({
  savingAmount
}) => {
  const formattedSavingAmount = (0,number_es/* formatCurrency */.x)(savingAmount);
  return /* @__PURE__ */ react.createElement(Wrapper, {
    background: MobileSavingBadge_es_background
  }, /* @__PURE__ */ react.createElement(Title, {
    size: "s"
  }, (0,i18n_es.t)("TI\u1EBET KI\u1EC6M")), /* @__PURE__ */ react.createElement(DiscountAmount, {
    size: "s"
  }, formattedSavingAmount));
};
const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(({ background: background2, theme }) => `
  height: 36px;
  line-height: 12px;
  background: url("${background2}");
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${theme.spacing.s4} ${theme.spacing.s8};
  border-radius: ${theme.borderRadius.s};
  background-size: cover;
`);
const Title = emotion_styled_browser_esm/* default.div */.Z.div(({ size }) => `
    font-size: ${MobileSavingBadge_es_SIZE[size].titleFont}px;
    font-weight: 700;
    color: #ffd591;
`);
const DiscountAmount = emotion_styled_browser_esm/* default.div */.Z.div(({ size, theme }) => `
    font-size: ${MobileSavingBadge_es_SIZE[size].discountFont}px;
    line-height: ${MobileSavingBadge_es_SIZE[size].discountLineHeight}px;
    font-weight: 700;
    color: ${theme.colors.white};
`);



// EXTERNAL MODULE: ../../packages/utils/dist/storage.es.js
var storage_es = __webpack_require__(53028);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/hooks/useQuantity.es.js
var useQuantity_es = __webpack_require__(18104);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/FlashSaleBar/mobile/FlashSaleBar.es.js
var FlashSaleBar_es = __webpack_require__(70329);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(41425);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/EnhancedImage/EnhancedImage.es.js
var EnhancedImage_es = __webpack_require__(34567);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/ProductCard/MobileProductCard.es.js












var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MobileProductCard_es_SIZE = {
  s: {
    padding: "s12"
  },
  m: {
    padding: "s16"
  }
};
const MobileProductCard = ({
  name,
  link,
  imageUrl,
  price,
  freeship,
  hasGift,
  infoTags,
  titleTag,
  ctaButton,
  contactButton,
  stockQuantityText,
  stockQuantity,
  flashSale,
  addToCart,
  textColor,
  brand,
  tracking,
  ctaTracking,
  needConfirmAge,
  type,
  renderUom
}) => {
  const { showModal } = (0,hook_es/* useModal */.d)();
  const { qty, setQty, handleUpdateQty, onIncrease, onDecrease } = (0,useQuantity_es/* useQuantity */.R)(addToCart);
  const handleClickCtaButton = (e) => {
    e.preventDefault();
    if (needConfirmAge) {
      showModal({
        title: (0,i18n_es.t)("C\u1EA3nh b\xE1o"),
        children: /* @__PURE__ */ react.createElement(index_es/* Body */.uT, null, (0,i18n_es.t)("src.components.ProductCard.ProductCard.0")),
        okText: (0,i18n_es.t)("T\xF4i tr\xEAn 18 tu\u1ED5i"),
        cancelText: (0,i18n_es.t)("T\xF4i d\u01B0\u1EDBi 18 tu\u1ED5i"),
        onOk: () => {
          (0,storage_es/* setSessionStorageOver18YearOld */.Nr)(true);
          addToCart.onAddToCart();
        },
        width: "90%",
        okButtonProps: { block: true },
        cancelButtonProps: { block: true }
      });
    } else
      ctaButton.onClick(e);
  };
  const renderButton = () => {
    if (!addToCart)
      return null;
    const { quantityInCart } = addToCart;
    if (quantityInCart === 0) {
      if (ctaButton)
        return /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, ctaButton), {
          onClick: (e) => {
            ctaButton.onClick && handleClickCtaButton(e);
          }
        }), ctaTracking), {
          size: "s",
          block: true,
          padding: "s0"
        }));
      else
        return /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(__spreadValues(__spreadValues({}, contactButton), ctaTracking), {
          size: "s",
          block: true,
          padding: "s0"
        }));
    }
    if (quantityInCart > 0) {
      return /* @__PURE__ */ react.createElement(Quantity_es/* Quantity */.h, {
        block: true,
        quantity: qty,
        setQuantity: setQty,
        onMinus: onDecrease,
        onPlus: onIncrease,
        min: 0,
        max: Math.min(stockQuantity, 999),
        color: "primary500",
        size: "s",
        onBlur: handleUpdateQty,
        onKeyPress: (e) => {
          if (e.key === "Enter")
            handleUpdateQty();
        }
      });
    }
  };
  const productVisualWrapper = /* @__PURE__ */ react.createElement(ProductVisualWrapper, null, /* @__PURE__ */ react.createElement(ProductImageWrapper, null, /* @__PURE__ */ react.createElement(ProductImage, {
    hover: "zoom",
    height: "100%",
    objectFit: "contain",
    src: imageUrl,
    googleImageParams: {
      width: 300
    },
    alt: name
  })), hasGift && /* @__PURE__ */ react.createElement(StyledIconWrapper, null, /* @__PURE__ */ react.createElement(GiftColored_es/* GiftColored */.x, {
    size: 24
  })), (infoTags == null ? void 0 : infoTags.length) > 0 && /* @__PURE__ */ react.createElement(InfoTagsWrapper, null, infoTags.map((tag, index) => /* @__PURE__ */ react.createElement(InfoTag, __spreadValues({
    key: index
  }, tag)))), flashSale && /* @__PURE__ */ react.createElement(react.Fragment, null, flashSale.discountPercent && /* @__PURE__ */ react.createElement(FlashSaleBadgeWrapper, null, /* @__PURE__ */ react.createElement(MobileFlashSaleBadge, {
    discountPercent: flashSale.discountPercent
  })), /* @__PURE__ */ react.createElement(FlashSaleTimerWrapper, null, /* @__PURE__ */ react.createElement(FlashSaleBar_es/* FlashSaleBar */.P, __spreadValues({}, flashSale)))), (price == null ? void 0 : price.discountAmount) && /* @__PURE__ */ react.createElement(SavingBadgeWrapper, null, /* @__PURE__ */ react.createElement(MobileSavingBadge, {
    savingAmount: price.discountAmount
  })));
  const productName = /* @__PURE__ */ react.createElement(react.Fragment, null, brand && /* @__PURE__ */ react.createElement(Brand, null, /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    level: 2,
    line: 1,
    color: "textSecondary",
    hoverColor: "primary500",
    style: { textTransform: "uppercase" },
    onClick: (e) => {
      if (brand.onClick) {
        e.preventDefault();
        brand.onClick();
      }
    }
  }, brand.name)), /* @__PURE__ */ react.createElement(ProductNameWrapper, null, /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    level: 1,
    line: stockQuantityText ? 1 : 2,
    color: textColor || "textPrimary"
  }, titleTag && /* @__PURE__ */ react.createElement(TitleTag, __spreadValues({}, titleTag)), /* @__PURE__ */ react.createElement(StyledH3, null, name)), stockQuantityText && /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    level: 1,
    color: textColor || "pending600"
  }, stockQuantityText)), !!renderUom && renderUom, /* @__PURE__ */ react.createElement(ProductSaleInfo, {
    freeship
  }, freeship && /* @__PURE__ */ react.createElement(StyledIconWrapper, null, /* @__PURE__ */ react.createElement(FreeShippingColored_es/* FreeShippingColored */.h, {
    size: 24
  })), /* @__PURE__ */ react.createElement(ProductPrice_es/* ProductPrice */.j, __spreadValues({}, price))));
  const card = type === "list" ? /* @__PURE__ */ react.createElement("div", __spreadValues({
    style: { display: "flex", padding: "12px" },
    className: "product-card"
  }, tracking), /* @__PURE__ */ react.createElement("div", {
    style: { flex: 3 }
  }, productVisualWrapper), /* @__PURE__ */ react.createElement("div", {
    style: { flex: 7, marginLeft: "12px" }
  }, productName, renderButton())) : /* @__PURE__ */ react.createElement(MobileProductCard_es_Wrapper, __spreadValues({
    size: "s",
    className: "product-card"
  }, tracking), /* @__PURE__ */ react.createElement(ProductCardContent, null, productVisualWrapper, productName), renderButton());
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, __spreadValues({}, link), card));
};
const MobileProductCard_es_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(({ theme, size }) => `
    position: relative;
    width: 100%;
    padding: ${theme.spacing[MobileProductCard_es_SIZE[size].padding]};
    display: flex;
    flex-direction: column;
    background-color: #fff;
   `);
const StyledIconWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
`;
const ProductCardContent = emotion_styled_browser_esm/* default.div */.Z.div(({ theme }) => `
    position: relative;
    flex: 1 0 auto;
    margin-bottom: ${theme.spacing.s8};
`);
const ProductVisualWrapper = emotion_styled_browser_esm/* default.div */.Z.div(({ theme }) => `
    position: relative;
    margin-bottom: ${theme.spacing.s4};
`);
const ProductSaleInfo = emotion_styled_browser_esm/* default.div */.Z.div(({ theme, freeship }) => `
    position: relative;
    margin-top: ${theme.spacing.s4};
    padding-right: ${freeship ? "1.5rem" : "unset"} ;
`);
const Brand = emotion_styled_browser_esm/* default.div */.Z.div(({ theme }) => `
    margin-bottom: ${theme.spacing.s4};
`);
const TitleTag = (0,emotion_styled_browser_esm/* default */.Z)(Tag_es/* Tag */.V)(({ theme }) => `
  margin-right: ${theme.spacing.s4};
`);
const InfoTag = (0,emotion_styled_browser_esm/* default */.Z)(Tag_es/* Tag */.V)(({ theme }) => `
    margin-bottom: ${theme.spacing.s4};
  `);
const InfoTagsWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  top: 0;
  left: 0;
`;
const FlashSaleBadgeWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  position: absolute;
  top: 0;
  right: 0;
`;
const FlashSaleTimerWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;
const SavingBadgeWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  position: absolute;
  bottom: 0;
  left: 0;
`;
const ProductImageWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  position: relative;
  padding-bottom: 100%;
`;
const ProductImage = (0,emotion_styled_browser_esm/* default */.Z)(EnhancedImage_es/* EnhancedImage */.N)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  object-fit: contain;
`;
const ProductNameWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  height: 2rem;
`;
const StyledH3 = emotion_styled_browser_esm/* default.h3 */.Z.h3`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  display: inline;
`;




/***/ }),

/***/ 37244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ MobileProductCarousel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28247);
/* harmony import */ var _ProductCard_MobileProductCard_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92316);
/* harmony import */ var _HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34469);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MobileProductCarousel = ({
  products,
  productsPerRow,
  regionName,
  hideCtaButton
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "wrapper-horizontal-slider"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_1__/* .HorizontalSlider */ .r, {
    slidesPerView: productsPerRow || 2.3,
    className: "horizontal-slider"
  }, products.map((product, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_MobileProductCard_es_js__WEBPACK_IMPORTED_MODULE_2__/* .MobileProductCard */ .e, __spreadProps(__spreadValues({
    key: index
  }, product), {
    tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O)({
      regionName,
      isTrackContent: true,
      contentName: product.sku,
      target: "productDetail"
    }) : {},
    addToCart: hideCtaButton ? null : product.addToCart
  })))));
};




/***/ }),

/***/ 26775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ProductCarousel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79096);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58735);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28247);
/* harmony import */ var _HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34469);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69168);
/* harmony import */ var _ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96790);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    products,
    productsPerRow,
    className,
    regionName,
    hideCtaButton
  } = _b, sliderSetting = __objRest(_b, [
    "products",
    "productsPerRow",
    "className",
    "regionName",
    "hideCtaButton"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const sliderConfig = __spreadValues(__spreadProps(__spreadValues({}, _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .defaultSlider */ .b), {
    spaceBetween: 12
  }), sliderSetting);
  if (isMobile) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "wrapper-horizontal-slider"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalSlider */ .r, {
      slidesPerView: productsPerRow || 2.3,
      className: "horizontal-slider"
    }, products.map((product, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({
      key: index
    }, product), {
      tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O)({
        regionName,
        isTrackContent: true,
        contentName: product.sku,
        target: "productDetail"
      }) : {},
      addToCart: hideCtaButton ? null : product.addToCart
    })))));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSlider, __spreadProps(__spreadValues({}, sliderConfig), {
    slidesPerView: productsPerRow || 5,
    className
  }), products.map((item) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Card, {
    key: item.sku
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, item), {
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O)({
      regionName,
      isTrackContent: true,
      contentName: item.sku,
      target: "productDetail"
    }),
    addToCart: hideCtaButton ? null : item.addToCart
  })))));
};
const Card = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div`
  background: white;
  border-radius: 0.5rem;
`;
const StyledSlider = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Slider */ .i)`
  .swiper-slide {
    max-width: 230px;
  }
`;




/***/ }),

/***/ 34208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ index_es_Tab; }
});

// UNUSED EXPORTS: MobileTab

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Tab/mobile/Tab.es.js
var Tab_es = __webpack_require__(55164);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(71323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(88384);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(49624);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(58519);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-46f73e5ea2/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(17016);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(25989);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/RightOutlined.es.js
var RightOutlined_es = __webpack_require__(63103);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(68481);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Countdown/Countdown.es.js + 1 modules
var Countdown_es = __webpack_require__(97161);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/ProductCarousel/ProductCarousel.es.js
var ProductCarousel_es = __webpack_require__(26775);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/helpers/image.es.js
var image_es = __webpack_require__(58754);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Tab/desktop/Tab.es.js









var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Tab = (_a) => {
  var _b = _a, {
    tabs,
    className
  } = _b, props = __objRest(_b, [
    "tabs",
    "className"
  ]);
  const [tabIndex, setTabIndex] = (0,react.useState)(0);
  const handleChangeTab = (event) => {
    setTabIndex(+event.currentTarget.dataset.index);
  };
  return /* @__PURE__ */ react.createElement(TabWrapper, __spreadValues({
    bgImage: tabs[tabIndex].backgroundImage,
    className
  }, props), /* @__PURE__ */ react.createElement(TabHeader, null, tabs.map((tab, index) => /* @__PURE__ */ react.createElement(TabItem, __spreadValues({
    key: index,
    "data-index": index,
    onClick: handleChangeTab,
    className: index === tabIndex ? "active" : ""
  }, (0,helper_es/* getTrackingData */.O)({
    isTrackContent: true,
    regionName: "hotDealTab",
    contentName: tab.title
  })), /* @__PURE__ */ react.createElement(index_es/* Title */.Dx, {
    line: 1,
    style: { textAlign: "center" }
  }, tab.title), tab.description && /* @__PURE__ */ react.createElement(index_es/* SubTitle */.DK, {
    line: 1,
    style: { textAlign: "center" }
  }, tab.description)))), /* @__PURE__ */ react.createElement("div", {
    style: { position: "relative", textAlign: "right", padding: "20px" }
  }, tabs[tabIndex].link && /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, {
    href: tabs[tabIndex].link
  }, /* @__PURE__ */ react.createElement("span", {
    style: { color: "white" }
  }, (0,i18n_es.t)("Xem t\u1EA5t c\u1EA3")), /* @__PURE__ */ react.createElement(RightOutlined_es/* RightOutlined */.g, {
    color: "white"
  }))), /* @__PURE__ */ react.createElement(Row_es/* Row */.X, null, /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
    span: 2,
    style: { margin: "auto" }
  }, /* @__PURE__ */ react.createElement(CountdownTime, {
    date: tabs[tabIndex].endAt
  })), /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
    span: 10
  }, /* @__PURE__ */ react.createElement(Carousel, null, /* @__PURE__ */ react.createElement(ProductCarousel_es/* ProductCarousel */.G, __spreadProps(__spreadValues({}, tabs[tabIndex].productsCarousel), {
    regionName: "hotDeal"
  }))))));
};
const TabWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  ${BaseProps_index_es/* CommonStyles */.F}
  ${(p) => p.bgImage && `background-image: url(${(0,image_es/* getImageUrlFromGoogleUserContent */.N)(p.bgImage || "", {
  width: 1232
})});
background-repeat: no-repeat;
background-size: cover;`}
  border-radius: 8px;
  padding-bottom: 12px;
`;
const TabHeader = emotion_styled_browser_esm/* default.div */.Z.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px 8px 0px 0px;
`;
const TabItem = emotion_styled_browser_esm/* default.div */.Z.div`
  height: 60px;
  padding: 0.5rem 1rem 0 1rem;
  border-radius: 5px 5px 0 0;
  flex: 1;
  cursor: pointer;
  background: white;
  color: rgb(132, 135, 136);
  position: relative;
  &.active {
    background: transparent;
    color: white;
  }
  &:not(:first-child):before {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white;
    position: absolute;
    left: -5px;
    top: 0;
  }
`;
const CountdownTime = (0,emotion_styled_browser_esm/* default */.Z)(Countdown_es/* Countdown */.I)`
  position: relative;
  left: 1rem;
  bottom: 0;
`;
const Carousel = emotion_styled_browser_esm/* default.div */.Z.div`
  margin-left: 48px;
  margin-right: 16px;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(69168);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/Tab/index.es.js






var index_es_defProp = Object.defineProperty;
var index_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var index_es_hasOwnProp = Object.prototype.hasOwnProperty;
var index_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var index_es_defNormalProp = (obj, key, value) => key in obj ? index_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var index_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (index_es_hasOwnProp.call(b, prop))
      index_es_defNormalProp(a, prop, b[prop]);
  if (index_es_getOwnPropSymbols)
    for (var prop of index_es_getOwnPropSymbols(b)) {
      if (index_es_propIsEnum.call(b, prop))
        index_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const index_es_Tab = (props) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  if (isMobile)
    return /* @__PURE__ */ react.createElement(Tab_es/* Tab */.O, index_es_spreadValues({}, props));
  return /* @__PURE__ */ react.createElement(Tab, index_es_spreadValues({}, props));
};




/***/ }),

/***/ 55164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Tab; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25989);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63103);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68481);
/* harmony import */ var _hooks_useTimer_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63860);
/* harmony import */ var _ProductCarousel_MobileProductCarousel_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37244);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Tab = (_a) => {
  var _b = _a, {
    tabs,
    className
  } = _b, props = __objRest(_b, [
    "tabs",
    "className"
  ]);
  const [tabIndex, setTabIndex] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  const handleChangeTab = (event) => {
    setTabIndex(+event.currentTarget.dataset.index);
  };
  const timer = (0,_hooks_useTimer_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useTimer */ .J)(tabs[tabIndex].endAt);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabWrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabHeader, null, tabs.slice(0, 4).map((tab, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabItem, {
    key: index,
    "data-index": index,
    onClick: handleChangeTab,
    className: index === tabIndex ? "active" : ""
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    level: 1,
    weight: "medium",
    line: 2,
    className: "title"
  }, tab.title), tab.description && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
    level: 3,
    weight: "regular",
    line: 2
  }, tab.description), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Timer, null, timer.hours.toString().padStart(2, "0"), "\xA0:\xA0", timer.minutes.toString().padStart(2, "0"), "\xA0:\xA0", timer.seconds.toString().padStart(2, "0")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Decor, null)))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    bgImage: tabs[tabIndex].backgroundImage,
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { textAlign: "right", padding: "32px 16px" }
  }, tabs[tabIndex].link && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .CustomLink */ .x, {
    href: tabs[tabIndex].link
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: { color: "white" }
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Xem t\u1EA5t c\u1EA3")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .RightOutlined */ .g, {
    color: "white"
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCarousel_MobileProductCarousel_es_js__WEBPACK_IMPORTED_MODULE_6__/* .MobileProductCarousel */ .I, __spreadValues({}, tabs[tabIndex].productsCarousel))));
};
const TabWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .Z.div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .CommonStyles */ .F);
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .Z.div`
  background: url(${(props) => props.bgImage});
  background-size: cover;
  background-position: center center;
  margin-bottom: 8px;
  padding: 16px 8px;
`;
const TabHeader = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .Z.div`
  height: 60px;
  display: flex;
  margin-left: 16px;
`;
const TabItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .Z.div(({ theme }) => `
  width: 84px;
  height: 84px;
  text-align: center;
  margin-right: 8px;
  padding: 16px 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background: white;
  color: ${theme.colors.textSecondary};
  border: 1px solid ${theme.colors.border};
  border-radius: 8px;
  position: relative;
  &.active {
    background: ${theme.colors.primary700};
    color: white;
    padding: 0;
    transition: all 0.2s ease-in-out 0s;
    border-style: none;
    .title{
      color: white;
    }
  }
`);
const Decor = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .Z.div(({ theme }) => `
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  position: absolute;
  bottom: -5px;
  .active & {
    background: ${theme.colors.primary700};
  }
`);
const Timer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .Z.div(({ theme }) => `
  padding: 0 8px;
  font-size: 10px;
  background: white;
  border-radius: 5px;
  display: none;
  z-index: 5;
  .active & {
    color: ${theme.colors.link700};
    display: block;
    font-weight: 400;
  }
`);




/***/ }),

/***/ 58735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ defaultSlider; }
/* harmony export */ });
const defaultSlider = {
  slidesPerView: 5,
  slidesPerColumn: 1,
  navigation: true,
  navigationStyle: 1,
  pagination: false,
  paginationStyle: 1,
  autoplay: false,
  loop: false,
  spaceBetween: 16
};




/***/ }),

/***/ 63860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useTimer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _helpers_time_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83908);



const useTimer = (endAt) => {
  const [time, setTime] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_time_es_js__WEBPACK_IMPORTED_MODULE_1__/* .calculateTimeDelta */ .m)(new Date(), endAt));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const timer = setInterval(() => setTime((0,_helpers_time_es_js__WEBPACK_IMPORTED_MODULE_1__/* .calculateTimeDelta */ .m)(new Date(), endAt)), 1e3);
    return () => {
      clearInterval(timer);
    };
  }, [endAt]);
  return time;
};




/***/ })

}]);